class NutritionTable extends HTMLElement {
  constructor() {
    super();
  }
  update() {
    const input_value = Math.min(Math.max(Number(this.input.min), Number(this.input.value)), Number(this.input.max));
    if(this.input.value) {
      this.input.value = input_value;
    }
    const multiplier = input_value / 100.0;
    const base_values = this.querySelectorAll('[data-base]');
    const serving_size_display = this.querySelector('[data-serving-size]');
    if(serving_size_display) {
      serving_size_display.innerHTML = input_value+'g';
    }
    for (const base_value of base_values) {
      const name = base_value.dataset.base;
      const value = Number(base_value.dataset.baseValue);
      const serving_values = this.querySelectorAll(`[data-serving-${name}]`);
      for (const serving_value of serving_values) {
        const raw_number = value * multiplier
        const rounded_number = raw_number < 0.1 ? Math.round(raw_number * 100) / 100 : Math.round(raw_number * 10) / 10;
        let default_fractional = '0';
        if (raw_number < 0.1) {
          const rounded_number = Math.round(raw_number * 100) / 100;
          default_fractional = '00';
        } else {
          const rounded_number = Math.round(raw_number * 10) / 10;
        }
        const number_split = `${rounded_number}`.split('.');
        const integral = number_split[0];
        let fractional = default_fractional;
        if (raw_number < 0.1) {
          if (number_split[1] != null) {
            fractional = (`${number_split[1]}` + default_fractional).slice(0, 2);
          }
        } else {
          if (number_split[1] != null) {
            fractional = (`${number_split[1]}` + default_fractional).slice(0, 1);
          }
        }
        serving_value.innerHTML = integral + "," + fractional;
      }
    }
  }
  connectedCallback() {
    this.slider = this.closest('embla-slider');
    this.input = null;
    if(this.closest('embla-slider')) {
      this.input = this.closest('details')?.querySelector('.serving-size-input');
    } else {
      this.input = this.querySelector('.serving-size-input');
    }
    this.input?.addEventListener('input', () => {
      this.update();
    });
    this.update();
  }
}
if ("customElements" in window && !customElements.get("nutrition-table")) {
  customElements.define("nutrition-table", NutritionTable);
}